import { useState } from "react";
import { Copy, KeyRound, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export function CredentialDialog({ creds, onClose }) {
  const [copied, setCopied] = useState(false);
  if (!creds) return null;
  const copy = async () => {
    await navigator.clipboard?.writeText(`Username: ${creds.username}\nTemporary password: ${creds.temp_password}`);
    setCopied(true);
    toast.success("Credentials copied");
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-3xl" data-testid="credential-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><KeyRound size={18} className="text-purple-600" /> Login credentials issued</DialogTitle>
          <DialogDescription>This temporary password is shown only once. Hand it to the account holder securely. They must change it on first sign-in.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 rounded-2xl bg-slate-50 p-4">
          <div><p className="label">Username</p><p className="font-mono text-base font-semibold" data-testid="issued-username">{creds.username}</p></div>
          <div><p className="label">Temporary password</p><p className="font-mono text-base font-semibold text-purple-700" data-testid="issued-temp-password">{creds.temp_password}</p></div>
        </div>
        <div className="flex items-center gap-2 text-xs text-slate-500"><ShieldCheck size={14} /> Passwords are stored hashed; admins cannot view them later.</div>
        <div className="flex gap-2">
          <button className="btn-secondary flex-1" onClick={copy} data-testid="copy-credentials-button"><Copy size={15} /> {copied ? "Copied" : "Copy"}</button>
          <button className="btn-primary flex-1" onClick={onClose} data-testid="close-credentials-button">Done</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
